import type { CommentItem, TodoActionRights, TodoItem, TodoRelationship, TodoStatus } from "@zero/types/todo";

export function deriveTodoRelationship(
  todo: Pick<TodoItem, "ownerId" | "assigneeId">,
  userId?: string,
): TodoRelationship {
  if (userId && todo.ownerId === userId) return "owner";
  if (userId && todo.assigneeId === userId) return "assignee";
  return "viewer";
}

export function deriveTodoActionRights(relationship: TodoRelationship): TodoActionRights {
  const accessible = relationship === "owner" || relationship === "assignee";
  return {
    canRead: true,
    canEdit: accessible,
    canTransitionStatus: accessible,
    canDelete: relationship === "owner",
    canAssign: relationship === "owner",
    canComment: accessible,
  };
}

export function canEditComment(comment: Pick<CommentItem, "authorId">, userId?: string): boolean {
  return Boolean(userId && comment.authorId === userId);
}

export function canDeleteComment(
  comment: Pick<CommentItem, "authorId">,
  todo: Pick<TodoItem, "ownerId">,
  userId?: string,
): boolean {
  return Boolean(userId && (comment.authorId === userId || todo.ownerId === userId));
}

export function isTodoCompleted(todo: Pick<TodoItem, "status">): boolean {
  return todo.status === "completed";
}

export function isTodoInProgress(todo: Pick<TodoItem, "status">): boolean {
  return todo.status === "inProgress";
}

export function isTodoArchived(todo: Pick<TodoItem, "status">): boolean {
  return todo.status === "archived";
}

export function statusWeight(status: TodoStatus): number {
  const weights: Record<TodoStatus, number> = {
    pending: 0,
    inProgress: 1,
    completed: 2,
    archived: 3,
  };
  return weights[status];
}
